module.exports = __webpack_public_path__ + "img/topo.b10f9735.jpg";